var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"column"},[_c('vs-progress',{attrs:{"height":12,"indeterminate":"","color":"#4C77B6"}},[_vm._v("primary")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }